/**
 * LiveScheduleSheet — bottom-sheet showing today's session list, opened by tapping the progress bar.
 *
 * UI-INV-005: Leaf component — props only, no engine imports.
 */
import styles from "./LiveScheduleSheet.module.css";
import { IntentStrip } from "../components/IntentStrip";
import { TEST_IDS } from "../testing/testIds";

export type SheetSession = {
  name: string;
  startLabel: string;
  durationLabel: string;
  status: "done" | "current" | "next" | "upcoming";
  /** Used by LiveScreen to place timeline tick marks. */
  durationSeconds?: number;
};

type Props = {
  sessions: SheetSession[];
  intentLabels: string[];
  dayLabel: string;
  retreatEndsLabel: string;
  whisperLine?: string;
  onDismiss: () => void;
};

export function LiveScheduleSheet({
  sessions,
  intentLabels,
  dayLabel,
  retreatEndsLabel,
  whisperLine,
  onDismiss,
}: Props) {
  return (
    <div className={styles.backdrop} onClick={onDismiss} data-testid={TEST_IDS.LIVE_SCHEDULE_SHEET}>
      <div className={styles.sheet} onClick={(e) => e.stopPropagation()}>
        <div className={styles.dragHandle} onClick={onDismiss} />

        <div className={styles.header}>
          <div className={styles.headerRow}>
            <span className={styles.dayLabel}>{dayLabel}</span>
            <span className={styles.endsLabel}>{retreatEndsLabel}</span>
          </div>
          <IntentStrip intents={intentLabels} />
        </div>

        <div className={styles.sessionList}>
          {sessions.map((s, i) => (
            <div
              key={i}
              className={[
                styles.sessionRow,
                s.status === "done" ? styles.done : "",
                s.status === "current" ? styles.current : "",
                s.status === "next" ? styles.next : "",
              ].join(" ")}
            >
              <span className={styles.sessionTime}>{s.startLabel}</span>
              <span className={styles.sessionName}>
                {s.status === "current" ? "▸ " : ""}{s.name}
              </span>
              <span className={styles.sessionDuration}>{s.durationLabel}</span>
            </div>
          ))}
        </div>

        {whisperLine && (
          <div className={styles.footer}>
            <span className={styles.footerWhisper}>{whisperLine}</span>
          </div>
        )}
      </div>
    </div>
  );
}
